import { QueryClient } from '@tanstack/react-query';

import { SnakeIdObj } from '@synapex/tools/typescript';

import { getOne } from '../api-client/channel-request';
// import * as Selector from '../entity/selector';
import { mapAccount } from './cache/all';
import { all } from './key-fn';
/*

export const pollNewAccount = (
  queryClient: QueryClient,
  p: SnakeIdObj<'telegram_channel', string>,
  opts: { abortController?: AbortController },
) =>
  ApiClient.pollNewAccount(p, opts).then((reply) => {
    if (!reply) {
      return undefined;
    }

    const queryKey = all().queryKey;
    const { invite: _, ...advertiserAccount } = reply;

    queryClient.setQueryData(queryKey, (userData) =>
      userData
        ? {
            ...userData,
            advertiserAccounts: [
              advertiserAccount,
              ...userData.advertiserAccounts,
            ],
          }
        : userData,
    );
    void queryClient.invalidateQueries({
      queryKey,
    });

    return Selector.createdAccountAndInvite(reply);
  });

export const pollNewChannel = (
  queryClient: QueryClient,
  p: SnakeIdObj<'telegram_channel', string>,
  opts: { abortController?: AbortController },
) => {
  return ApiClient.pollNewChannel(p, opts).then((newChannelWorkspace) => {
    if (!newChannelWorkspace) {
      return undefined;
    }

    const queryKey = all().queryKey;

    queryClient.setQueryData(queryKey, (userData) =>
      userData && newChannelWorkspace.advertiser_account_id
        ? mapAccount(
            userData,
            {
              advertiser_account_id: newChannelWorkspace.advertiser_account_id,
            },
            (aa) => ({
              ...aa,
              workspaces: [newChannelWorkspace, ...aa.workspaces],
            }),
          )
        : userData,
    );
    void queryClient.invalidateQueries({
      queryKey,
    });

    return newChannelWorkspace;
  });
};
*/

export const queryChannelRequest = (
  queryClient: QueryClient,
  p: SnakeIdObj<'telegram_channel', string>,
  abortController?: AbortController,
) => {
  return getOne(p, abortController).then((result) => {
    if (
      result.status === 'PENDING_ACCOUNT' ||
      result.status === 'PENDING_CHANNEL'
    ) {
      return result;
    }

    const queryKey = all().queryKey;

    queryClient.setQueryData(queryKey, (data) => {
      if (!data) {
        return data;
      }

      if (result.status === 'CHANNEL') {
        //remove channel request, add channel
        return mapAccount(
          data,
          { advertiser_account_id: result.channel.advertiser_account_id },
          (acc) => ({
            ...acc,
            workspaces: [result.channel, ...acc.workspaces],
            channelRequests: acc.channelRequests.filter(
              (cr) =>
                cr.telegram_channel_id !== result.channel.telegram_channel_id,
            ),
          }),
        );
      } else {
        //remove channel request, add account
        return {
          ...data,
          advertiserAccounts: [
            result.advertiserAccount,
            ...data.advertiserAccounts,
          ],
          channelRequests: data.channelRequests.filter(
            (cr) => cr.telegram_channel_id !== result.status,
          ),
        };
      }
    });

    void queryClient.invalidateQueries({
      queryKey,
    });

    return result;
  });
};
